import * as Yup from "yup"
import { TRANSLATION_INDEX_GLOBAL } from "../../config/translation"

export default Yup.object().shape({
  newPass: Yup.string().required(TRANSLATION_INDEX_GLOBAL.REQUIRED),
  repeat: Yup.string().required(TRANSLATION_INDEX_GLOBAL.REQUIRED)
})
